import { setSpecificMessage, bytes } from "valibot";
setSpecificMessage(
  bytes,
  (issue) => `Octet invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);